








import Vue from 'vue'
import SolidPrimaryButton from '@/components/buttons/SolidPrimaryButton.vue'

export default Vue.extend({
  name: 'SubmitButton',
  components: { SolidPrimaryButton },
  props: {
    color: { type: String, default: 'primary' },
    text: { type: Boolean, default: false },
  },
  computed: {
    btnColor(): string {
      if (this.color === 'green') return 'primary'
      if (this.color === 'red') return 'error'
      return this.color || 'primary'
    },
  },
})
